import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createFoldOutbound } from '../../../../api/outbound/pokerOutbounds';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
export const DomFoldButton = ({ bounds, myTurnProperties }) => {
    const socketSend = useSocketSend();
    const onClickFold = useCallback(() => {
        socketSend(createFoldOutbound(myTurnProperties.betSequenceNumber));
    }, [myTurnProperties, socketSend]);
    const { x, y, w, h } = bounds;
    return _jsx(ScaledTextButton, { onClick: onClickFold, label: 'FOLD', testId: 'fold', x: x, y: y, w: w, h: h, accentColor: 'red' });
};
